import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal, Form, Input, Button, Alert, message, Select, DatePicker, ConfigProvider, theme } from 'antd';
import Ink from 'react-ink';

import dayjs from 'dayjs';
import countries from '../../../config/countriesInfo.json';

import {
	organizationList,
	organizationCreate,
	organizationUpdate
} from '../../../modules/organization';

import { AppstoreOutlined, AppstoreAddOutlined, ArrowRightOutlined } from '@ant-design/icons';

const { Option } = Select;
const FormItem = Form.Item;

class AddOrganizationModal extends Component {
	formRef = React.createRef();
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			message: null
		}
	}

	handleSubmit = (values) => {
		const { organizations } = this.props;
		this.setState({ loading: true });
		values.active = (values.status === 'active');
		if (this.props.data === 'new') {
			this.props.organizationCreate(values).then(
				(res) => {
					message.success('Organization successfully added!');
					this.setState({ loading: false, message: null });
					if (this.formRef.current) { this.formRef.current.resetFields(); }
					this.onClose();
				},
				(err) => {
					this.setState({ loading: false, message: `Can't get through. Please make sure email is unique or contact the administrator.` });
				}
			);
		} else {
			let selectOrg = organizations.find(org => (org.code === this.props.data));
			this.props.organizationUpdate(values, selectOrg._id).then(
				(res) => {
					message.success('Organization successfully updated!');
					this.setState({ loading: false, message: null });
					if (this.formRef.current) { this.formRef.current.resetFields(); }
					this.onClose();
				},
				(err) => {
					this.setState({ loading: false, message: `Can't get through. Please make sure email is unique or contact the administrator.` });
				}
			);
		}
	}

	onClose() {
		this.setState({
			message: null
		});
		if (this.formRef.current) { this.formRef.current.resetFields(); }
		this.props.organizationList();
		this.props.toggleAddOrganizationModal();
	}


	render() {
		const { defaultAlgorithm, darkAlgorithm } = theme;
		const { loading, message } = this.state;
		const { organizations, userProfile, userTheme } = this.props;
		const id = this.props.data;

		const formItemLayout = {
			labelCol: { span: 8 },
			wrapperCol: { span: 14 },
		};
		let initialValues = (id === 'new') ? { code: null, name: null, active: null } : organizations.find(org => (org.code === id));
		initialValues.status = initialValues.status === 'active' ? 'active' : 'inactive';
		if (initialValues.serviceStartDate) {
			initialValues.serviceStartDate = dayjs(initialValues.serviceStartDate);
		}
		if (initialValues.serviceEndDate) {
			initialValues.serviceEndDate = dayjs(initialValues.serviceEndDate);
		}
		if (this.formRef.current && !loading) {
			this.formRef.current.setFieldsValue(initialValues);
		}

		let superadmin = (userProfile && userProfile.user && userProfile.user.access && userProfile.user.access.includes("crossOrganization") && userProfile.user.role.includes("admin")) ? true : false;
		let admin = (userProfile && userProfile.user && userProfile.user.role.includes("admin")) ? true : false;
		// let editor = (userProfile && userProfile.user && userProfile.user.role === "editor")?true:false;

		const handleButton = () => {

			this.formRef.current.setFieldsValue({ serviceEndDate: dayjs('2999-01-01T00:00:00.000Z') })


		};
		return (
			<ConfigProvider theme={{
				algorithm: userTheme === 'dark' ? darkAlgorithm : defaultAlgorithm,
			}}>
				<Modal
					title={(this.props.data !== 'new') ? <span><AppstoreOutlined /> Organization Details</span> : <span><AppstoreAddOutlined /> Add Organization</span>}
					open={this.props.show}
					onCancel={() => this.onClose()}
					footer={[
						<Button key="submit" form="myOrganisationForm" type="primary" htmlType="submit" disabled={loading} ><Ink /><ArrowRightOutlined /> Submit</Button>,
						<Button key="back" onClick={() => this.onClose()} disabled={loading}>Cancel</Button>
					]}
					maskClosable={false}
					closable={(loading) ? false : true}
				>
					<Form ref={this.formRef} name="myOrganisationForm" onFinish={this.handleSubmit} initialValues={initialValues} >
						{(message) ? <Alert message={message} type="error" style={{ marginBottom: '20px' }} showIcon /> : ""}
						<FormItem  {...formItemLayout} label="ID" name="code" rules={[{ required: true, message: 'Please input organization id' }]}>
							<Input disabled={(this.props.data !== 'new')} />
						</FormItem>
						<FormItem  {...formItemLayout} label="Name" name="name" rules={[{ required: true, message: 'Please input organization name' }]}>
							<Input disabled={!superadmin} />
						</FormItem>
						{superadmin &&
							<>
								<FormItem  {...formItemLayout} label="Content URL" name="contentURL" rules={[{ required: true, message: 'Please input organization Content URL' }]}>
									<Input disabled={!superadmin} />
								</FormItem>
								<FormItem  {...formItemLayout} label="Content URL(Sandbox)" name="contentURLSandbox" rules={[{ required: true, message: 'Please input organization Content URL (Sandbox)' }]}>
									<Input disabled={!superadmin} />
								</FormItem>
							</>}
						<FormItem  {...formItemLayout} label="Status" name="status" rules={[{ required: true }]}>
							<Select disabled={!superadmin} >
								<Option value="active">Active</Option>
								<Option value="inactive">Inactive</Option>
							</Select>
						</FormItem>
						<FormItem  {...formItemLayout} label="Contact Email" name="contact" >
							<Input disabled={!(superadmin || admin)} />
						</FormItem>
						<FormItem  {...formItemLayout} label="Contact Person" name="contactPerson" >
							<Input disabled={!(superadmin || admin)} />
						</FormItem>
						<FormItem  {...formItemLayout} label="Country" name="country">
							<Select disabled={!(superadmin || admin)} >
								{
									countries.map(d => {
										return <Option value={d.code}>{d.name}</Option>
									})
								}


							</Select>
							{/* <Input  disabled={!(superadmin || admin)} /> */}
						</FormItem>
						<FormItem  {...formItemLayout} label="Address" name="address" >
							<Input disabled={!(superadmin || admin)} />
						</FormItem>
						<FormItem  {...formItemLayout} label="Service Tier" name="serviceTier" >
							<Select disabled={!superadmin} >
								<Option value="01">01</Option>
								<Option value="02">02</Option>
								<Option value="03">03</Option>
							</Select>
						</FormItem>
						<FormItem  {...formItemLayout} label="Service Duration Start" name="serviceStartDate"  >
							<DatePicker format={"YYYY-MM-DD HH:00"} showTime={{ format: "hh" }} disabled={!superadmin} />
						</FormItem>
						<FormItem  {...formItemLayout} label="Service Duration End" name="serviceEndDate">
							<DatePicker format={"YYYY-MM-DD HH:00"} showTime={{ format: "hh" }} disabled={!superadmin} renderExtraFooter={() => <Button type="primary" onClick={handleButton}>
								Set End Date to NA
							</Button>} />

						</FormItem>


					</Form>


				</Modal>
			</ConfigProvider>
		);
	}
}


const mapStateToProps = state => ({
	router: state.router,
	organizations: state.organization.organizations,
	userProfile: state.user.userProfile,
	userTheme: state.user.userTheme
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			organizationList,
			organizationCreate,
			organizationUpdate
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(AddOrganizationModal);
